var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'jds-date-input': true,
  'font-sans-1': true,
}},[(_vm.showLabel)?_c('jds-form-control-label',[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('div',{class:{
    'jds-date-input__input': true,
    'jds-date-input__input--error': _vm.showErrorMsg,
    'jds-date-input__input--focus': _vm.isFocused,
    }},[_c('input',{ref:"input",attrs:{"type":"text","id":"date"},domProps:{"value":_vm.mValue},on:{"accept":_vm.onAccept,"complete":_vm.onComplete,"focus":function($event){_vm.isFocused = true},"blur":function($event){_vm.isFocused = false}}}),_c('icon-calendar',{class:{
      'jds-date-input__input-suffix-icon': true,
      'jds-date-input__input-suffix-icon--focus': _vm.isFocused,
    }})],1),(_vm.showErrorMsg)?_c('jds-form-control-error-message',[_vm._v(" "+_vm._s(_vm.mErrorMessage)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }